import { render, staticRenderFns } from "./emailSendBox.vue?vue&type=template&id=7085f53d&scoped=true"
import script from "./emailSendBox.vue?vue&type=script&lang=js"
export * from "./emailSendBox.vue?vue&type=script&lang=js"
import style0 from "./emailSendBox.vue?vue&type=style&index=0&id=7085f53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085f53d",
  null
  
)

export default component.exports